module.exports = __webpack_public_path__ + "static/app-store-button-f9a9362f48d403215492423f8ff76229.svg";